import script from "./EventInformationView.vue?vue&type=script&setup=true&lang=js"
export * from "./EventInformationView.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__